export type BaseRequirementValue =
  | "photo_id"
  | "proof_of_address"
  | "proof_of_income"
  | "form"
  | "other";

export interface BaseRequirementOption {
  value: BaseRequirementValue;
  label: string;
}

export const baseRequirementTypeOptions: BaseRequirementOption[] = [
  {
    value: "photo_id",
    label: "Photo ID",
  },
  {
    value: "proof_of_address",
    label: "Proof of Address",
  },
  {
    value: "proof_of_income",
    label: "Proof of Income",
  },
  {
    value: "form",
    label: "Form",
  },
  {
    value: "other",
    label: "Other",
  },
];
